import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { computed } from "vue";
import { getThemeColor } from "@/branding";


export default /*#__PURE__*/_defineComponent({
  __name: 'Badge',
  props: {
  color: String,
  size: String,
},
  setup(__props) {

const props = __props;



const sizes = {
  md: 'text-xs font-medium px-2.5 py-0.5',
  lg: 'font-sebibold px-3 py-2',
};

const theme = getThemeColor();

const colors = {
  blue: `bg-${theme}-100 text-${theme}-800`,
  gray: "bg-gray-100 text-gray-800",
  red: "bg-red-100 text-red-800",
  green: "bg-green-100 text-green-800",
  yellow: "bg-yellow-100 text-yellow-800",
  indigo: "bg-indigo-100 text-indigo-800",
  purple: "bg-purple-100 text-purple-800",
  pink: "bg-pink-100 text-pink-800",
};

const color: any = computed(() => props.color ?? 'gray');
const size: any = computed(() => props.size ?? 'md');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass(`me-2 rounded whitespace-nowrap block ${(colors as any)[_unref(color)] ?? ''} ${(sizes as any)[_unref(size)] ?? ''}`)
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})